<template>
  <div class="to-user-task-container">
    <div class="to-user-task-container__header">
      <h2 class="to-user-title" v-if="theActiveUser">{{ theActiveUser.name }}</h2>
      <select class="do-select" :value="null" @change="$emit('setTheActiveUserId', $event.target.value)">
        <option value="">Skift bruger..</option>
        <option v-for="user in users" :key="user.id" :value="user.id">
          {{ user.name }}
        </option>
      </select>
    </div>
    <UserTasks
      v-if="schoolYear && theActiveUser"
      :isShowHeader="false"
      :initialStartDate="schoolYear.employee_time_start"
      :initialEndDate="schoolYear.employee_time_end"
      :user_id="theActiveUser.id"
      :user_calendar_id="theActiveUser.user_calendar_id"
      :user_name="theActiveUser.name"
      :isShowPrintButton="false"
      :initialIsShowScheduled="false"
      :isCanSeeOtherUsers="false"
      :isReactive="true"
      :isPreviewAsEmployee="true"
    ></UserTasks>
  </div>
</template>

<script>
import UserTasks from '../User/UserTasks'

export default {
  components: {UserTasks},
  props: {
    theActiveUserId: {
      default: null
    },
    users: {
      type: Array,
      default: () => []
    },
    schoolYear: {
      default: () => null
    }
  },
  computed: {
    theActiveUser () {
      if (!this.theActiveUserId) {
        if (this.users.length > 0) {
          return this.users[0]
        }
        return null
      }
      return this.users.find(user => user.id === this.theActiveUserId * 1)
    }
  }
}
</script>

<style scoped>
.to-user-task-container {
  border: 1px solid #eee;
  margin-top: 1rem;
}

.to-user-task-container__header {
  display: flex;
  gap: 1rem;
  margin: 1rem 1rem 0 1rem;
}

</style>



// WEBPACK FOOTER //
// TaskOverviewSettingsUserTasks.vue?86fe14fc